module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "section section-white content-padded view-flex view-flex-middle"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "section-white view-warp"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "template-view"
  }, [_c('div', {
    staticClass: "template",
    style: ('background:' + _vm.theme.bodyColor)
  }, [_c('div', {
    staticClass: "template-header",
    style: ('background:' + _vm.theme.bgColor + ' url(' + _vm.headerBg + ') no-repeat 0 4px; background-size: 100% auto;')
  }, [_c('div', {
    staticClass: "template-title",
    style: ('color:' + _vm.theme.fontColor)
  }, [_vm._v("标题")])]), _vm._v(" "), _c('el-carousel', {
    attrs: {
      "height": "160px",
      "autoplay": false
    }
  }, _vm._l((_vm.form.bannerPicList), function(item, index) {
    return (item.url) ? _c('el-carousel-item', {
      key: index,
      style: ('background: url(' + _vm.wximageurl + item.url + ') no-repeat center; background-size: cover')
    }) : _vm._e()
  }), 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "hot"
  }, [_c('div', {
    staticClass: "hot-title"
  }, [_c('text', {
    staticClass: "title-txt"
  }, [_vm._v("热门课程")])]), _vm._v(" "), _c('div', {
    staticClass: "view-flex"
  }, [_c('div', {
    staticClass: "hot-item-01"
  }, [_c('div', {
    staticClass: "hot-img",
    style: ('background:' + _vm.theme.bgColor + ' url(' + _vm.wximageurl + _vm.form.hotGoods[0].url + ') center / cover no-repeat;')
  }), _vm._v(" "), _c('div', {
    staticClass: "hot-item-name"
  }, [_vm._v(_vm._s(_vm.form.hotGoods[0].item_name))])]), _vm._v(" "), _c('div', {
    staticClass: "view-flex view-flex-vertical view-flex-item"
  }, [_c('div', {
    staticClass: "view-flex-item hot-item-02"
  }, [_c('div', {
    staticClass: "hot-img",
    style: ('background:' + _vm.theme.bgColor + ' url(' + _vm.wximageurl + _vm.form.hotGoods[1].url + ') center / cover no-repeat;')
  }), _vm._v(" "), _c('div', {
    staticClass: "hot-item-name"
  }, [_vm._v(_vm._s(_vm.form.hotGoods[1].item_name))])]), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _vm._m(4)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "setting-view"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section-header with-border with-bg"
  }, [_vm._v("轮播图配置")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_vm._l((_vm.form.bannerPicList), function(item, index) {
    return _c('div', {
      staticClass: "setting-item slider"
    }, [_c('div', {
      staticClass: "setting-remove",
      on: {
        "click": function($event) {
          return _vm.handleDelBanner(index)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-trash-alt1"
    })]), _vm._v(" "), _c('div', [(item.url) ? _c('img', {
      staticClass: "banner-uploader",
      attrs: {
        "src": _vm.wximageurl + item.url
      },
      on: {
        "click": function($event) {
          return _vm.handleImgChange(index, 'banner')
        }
      }
    }) : _c('div', {
      staticClass: "banner-uploader",
      on: {
        "click": function($event) {
          return _vm.handleImgChange(index, 'banner')
        }
      }
    }, [_vm._m(5, true)])]), _vm._v(" "), _c('div', {
      staticClass: "goods-select",
      on: {
        "click": function($event) {
          return _vm.handleGoodsChange(index, 'banner')
        }
      }
    }, [(item.item_id) ? _c('div', [_vm._v("\n                " + _vm._s(item.type === 'goods' ? '商品' : '活动') + "：" + _vm._s(item.item_name) + "\n              ")]) : _c('div', {
      staticClass: "content-center"
    }, [_c('i', {
      staticClass: "iconfont icon-link",
      on: {
        "click": function($event) {
          return _vm.handleGoodsChange(index, 'banner')
        }
      }
    }), _vm._v("绑定商品")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "content-center"
  }, [_c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("只能上传jpg/png文件，且不超过2M （建议尺寸：375px * 200px）")]), _vm._v(" "), _c('el-button', {
    staticClass: "el-icon-plus banner-button-uploader",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAddBanner
    }
  }, [_vm._v("添加轮播图")])], 1)], 2)]), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section-header with-border with-bg"
  }, [_vm._v("热门商品配置")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, _vm._l((_vm.form.hotGoods), function(item, index) {
    return _c('div', {
      staticClass: "setting-item hot"
    }, [_c('div', {
      staticClass: "view-flex"
    }, [_c('div', {
      staticClass: "content-right-margin"
    }, [(item.url) ? _c('img', {
      staticClass: "banner-uploader",
      attrs: {
        "src": _vm.wximageurl + item.url
      },
      on: {
        "click": function($event) {
          return _vm.handleImgChange(index, 'hotGoods')
        }
      }
    }) : _c('div', {
      staticClass: "banner-uploader",
      on: {
        "click": function($event) {
          return _vm.handleImgChange(index, 'hotGoods')
        }
      }
    }, [_vm._m(6, true)])]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "layout-tip"
    }, [_c('div', {
      staticClass: "layout-left",
      style: (index === 0 ? 'background:#fff' : '')
    }), _vm._v(" "), _c('div', {
      staticClass: "layout-item"
    }, [_c('div', {
      staticClass: "layout-item layout-top",
      style: (index === 1 ? 'background:#fff' : '')
    }), _vm._v(" "), _c('div', {
      staticClass: "layout-item"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "frm-tips"
    }, [_vm._v("只能上传jpg/png文件，且不超过2M （建议尺寸：375px * 200px）")])])]), _vm._v(" "), _c('div', {
      staticClass: "goods-select",
      on: {
        "click": function($event) {
          return _vm.handleGoodsChange(index, 'hotGoods')
        }
      }
    }, [(item.item_id) ? _c('div', [_vm._v("\n                " + _vm._s(item.type === 'goods' ? '商品' : '活动') + "：" + _vm._s(item.item_name) + "\n              ")]) : _c('div', {
      staticClass: "content-center"
    }, [_c('i', {
      staticClass: "iconfont icon-link"
    }), _vm._v("绑定商品")])])])
  }), 0)])])]), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "select-goods-box",
    attrs: {
      "title": "选择商品",
      "width": "820px",
      "visible": _vm.selectGoodsVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.selectGoodsVisible = $event
      }
    }
  }, [
    [_c('el-form', {
      attrs: {
        "label-width": "70px"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "选择路径"
      }
    }, [_c('el-radio-group', {
      on: {
        "change": _vm.switchType
      },
      model: {
        value: (_vm.type),
        callback: function($$v) {
          _vm.type = $$v
        },
        expression: "type"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": 'goods'
      }
    }, [_vm._v("商品")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": 'marketing'
      }
    }, [_vm._v("营销")])], 1)], 1), _vm._v(" "), (_vm.type === 'goods') ? _c('el-form-item', {
      attrs: {
        "label": "配置数据"
      }
    }, [_c('el-transfer', {
      attrs: {
        "titles": ['商品列表', '已选中'],
        "button-texts": ['移除选择', '添加选择'],
        "data": _vm.goodsList
      },
      on: {
        "change": _vm.handleSelectChange
      },
      model: {
        value: (_vm.selectGoods),
        callback: function($$v) {
          _vm.selectGoods = $$v
        },
        expression: "selectGoods"
      }
    }, [_c('div', {
      staticClass: "transfer-footer",
      attrs: {
        "slot": "left-footer"
      },
      slot: "left-footer"
    }, [(_vm.total_count > _vm.params.pageSize) ? _c('el-pagination', {
      attrs: {
        "small": "",
        "layout": "prev, pager, next",
        "total": _vm.total_count,
        "page-size": _vm.params.pageSize
      },
      on: {
        "current-change": _vm.handleSelectGoodsChange
      }
    }) : _vm._e()], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'marketing') ? _c('el-form-item', {
      attrs: {
        "label": "配置数据"
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "请选择"
      },
      model: {
        value: (_vm.selectedMarketing),
        callback: function($$v) {
          _vm.selectedMarketing = $$v
        },
        expression: "selectedMarketing"
      }
    }, _vm._l((_vm.marketingList), function(item, index) {
      return _c('el-option', {
        key: index,
        attrs: {
          "label": item.title,
          "value": item.value
        }
      })
    }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "section-footer with-border content-center",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.handleGoodsDialog
      }
    }, [_vm._v("确定")])], 1)]
  ], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view-flex view-flex-middle view-flex-item"
  }, [_c('div', [_vm._v("主题：")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "theme-item"
  }, [_c('div', {
    staticStyle: {
      "background": "#fc7900"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#242526"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-view"
  }, [_c('div', {
    staticClass: "page active"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": require("../../../../../static/img/wxapp_member_sport.jpg"),
      "height": "569",
      "width": "320"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view-flex view-flex-middle nav"
  }, [_c('div', {
    staticClass: "view-flex-item content-center nav-item left-nav"
  }, [_vm._v("我要买课")]), _vm._v(" "), _c('div', {
    staticClass: "view-flex-item content-center nav-item right-nav"
  }, [_vm._v("我要预约")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hot-more"
  }, [_vm._v("更多 "), _c('img', {
    staticClass: "hot-more-img",
    attrs: {
      "src": require("../../../../../static/img/arrow.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "store"
  }, [_c('div', {
    staticClass: "store-more store-label"
  }, [_vm._v("全部门店")]), _vm._v(" "), _c('div', {
    staticClass: "content-center"
  }, [_c('div', {
    staticClass: "store-name"
  }, [_vm._v("桂林路店")]), _vm._v(" "), _c('div', {
    staticClass: "store-desc"
  }, [_vm._v("上海市徐汇区桂林路396号2号楼")])]), _vm._v(" "), _c('div', {
    staticClass: "view-flex view-flex-center store-contact"
  }, [_c('div', {
    staticClass: "store-contact-item"
  }, [_c('img', {
    staticClass: "store-icon",
    attrs: {
      "src": require("../../../../../static/img/store_location.png")
    }
  }), _vm._v(" "), _c('div', [_vm._v("1220 km")])]), _vm._v(" "), _c('div', {
    staticClass: "store-contact-item"
  }, [_c('img', {
    staticClass: "store-icon",
    attrs: {
      "src": require("../../../../../static/img/store_phone.png")
    }
  }), _vm._v(" "), _c('div', [_vm._v("咨询")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-center"
  }, [_c('i', {
    staticClass: "iconfont icon-camera"
  }), _c('br'), _vm._v("\n                  上传图片\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-center"
  }, [_c('i', {
    staticClass: "iconfont icon-camera"
  }), _c('br'), _vm._v("\n                    上传图片\n                  ")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-11902eb3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11902eb3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/wxapp/template/store/sport.vue
// module id = 2475
// module chunks = 0